module.exports = __webpack_public_path__ + "img/logo.c2937a5f.png";